import type { LucideIcon } from "lucide-react";

// Shared chrome for the activity-editor panels (trim, strip, sport, time,
// device): a glass card with an icon + title header and an optional Reset
// affordance. Panel-specific content (subtitle, controls) is passed as children.
export function EditPanel({
  icon: Icon,
  title,
  onReset,
  children,
}: {
  icon: LucideIcon;
  title: string;
  onReset?: () => void;
  children: React.ReactNode;
}) {
  return (
    <div className="rounded-xl p-6 glass-panel">
      <div className="flex items-center justify-between mb-1">
        <h4 className="font-bold flex items-center gap-2">
          <Icon className="size-4 text-primary" />
          {title}
        </h4>
        {onReset && (
          <button
            type="button"
            onClick={onReset}
            className="text-xs font-medium text-primary hover:underline"
          >
            Reset
          </button>
        )}
      </div>
      {children}
    </div>
  );
}
